import { formatEnum } from '@cbgms/base/utils/helpers'

interface Props {
  content: {
    type: string
    value: string
  }
}

export function Enum({ content }: Props) {
  return <>{formatEnum(content.type, content.value)}</>
}
